import { takeEvery, put, call } from '@redux-saga/core/effects';
import {
  create_recipe_group,
  create_recipe_group_success,
  create_recipe_group_error,
  get_recipe_group,
  get_recipe_group_success,
  get_recipe_group_error,
  remove_recipe_group,
  remove_recipe_group_success,
  remove_recipe_group_error,
  update_recipe_group,
  update_recipe_group_success,
  update_recipe_group_error,
  get_single_recipe_group,
  get_single_recipe_group_success,
  get_single_recipe_group_error
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';
import { FileUploadToCloud } from '@app/services/fileUploadService';

function* createRecipeGroups({ payload }) {
  try {
    let image = ``;
    if (payload.image !== null) {
      const uploadImage = yield call(FileUploadToCloud, payload.image);
      image = uploadImage.secure_url;
    }
    const data = {
      ...payload,
      image
    };
    const request = yield call(api.post, '/recipe_groups', data);
    const request_res = request.data;
    const response = request_res.data;
    toast.success(request_res.message);
    const closeBtn = document.getElementById('close');
    closeBtn?.click();
    yield put({
      type: create_recipe_group_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: create_recipe_group_error.type
    });
  }
}

function* getRecipeGroups({ payload }) {
  try {
    const { page = 1, limit = 10, search } = payload;
    let request = ``;
    if (search) {
      request = yield call(api.get, `/recipe_groups?name=${search}`);
    } else {
      request = yield call(api.get, `/recipe_groups?page=${page}&limit=${limit}`);
    }
    const request_res = request.data;
    const response = request_res.data;
    yield put({
      type: get_recipe_group_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: get_recipe_group_error.type
    });
  }
}

function* removeRecipeGroup({ payload }) {
  try {
    const request = yield call(api.delete, `/recipe_groups/${payload}`);
    const request_res = request.data;
    const response = request_res.data;
    toast.success(request_res.message);
    yield put({
      type: remove_recipe_group_success.type,
      payload: response
    });
  } catch (error) {
    yield put({
      type: remove_recipe_group_error.type
    });
  }
}

function* updateRecipeGroups({ payload }) {
  try {
    const { data, id } = payload;
    let image = ``;
    if (typeof data.image === 'object') {
      const file = yield call(FileUploadToCloud, data.image);
      image = file.secure_url;
    } else {
      image = data.image;
    }
    let doc = {
      ...data,
      image
    };
    const request = yield call(api.patch, `/recipe_groups/${id}`, doc);
    const request_res = request.data;
    const response = request_res.data;
    toast.success(request_res.message);
    yield put({
      type: update_recipe_group_success.type,
      payload: response
    });
    const closeBtn = document.getElementById('close');
    closeBtn?.click();
  } catch (error) {
    yield put({
      type: update_recipe_group_error.type
    });
  }
}

function* getSingleRecipeGroup({ payload }) {
  try {
    const request = yield call(api.get, `/recipe_groups/${payload}`);
    const request_res = request.data;
    const response = request_res.data;
    yield put({
      type: get_single_recipe_group_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Failed to fetch recipe group');
    yield put({
      type: get_single_recipe_group_error.type
    });
  }
}

function* RecipeGroupSagas() {
  yield takeEvery(create_recipe_group.type, createRecipeGroups);
  yield takeEvery(get_recipe_group.type, getRecipeGroups);
  yield takeEvery(remove_recipe_group.type, removeRecipeGroup);
  yield takeEvery(update_recipe_group.type, updateRecipeGroups);
  yield takeEvery(get_single_recipe_group.type, getSingleRecipeGroup);
}

export default RecipeGroupSagas;
